module.exports = __webpack_public_path__ + "static/media/banner-right.939f499a.png";